import React from "react";

const paperStyle = style => ({
  backgroundColor: "#fff",
  padding: "2em",
  boxShadow: "0 4px 8px rgba(0, 0, 0, .15)",
  fontFamily: "Lato",
  maxHeight: "calc(100vh - 10em)",
  overflowY: "auto",
  ...style
});

const Paper = ({ style, children }) => (
  <div style={paperStyle(style)}>{children}</div>
);

export default Paper;



// WEBPACK FOOTER //
// ./src/components/bcase/Paper.js